// extracted by mini-css-extract-plugin
export default {"wrap":"ForgotPasswordPage_wrap__m3avE"};